import { PlayerAudio } from "../interfaces/player/player.interface";

export const setAudioFilterVisibility = (language: string, topicLabel: string, audioQueue: PlayerAudio[]): PlayerAudio[] => {
    try {
        let order = 0;
        return audioQueue.map(audio => {
            if (audio?.language === language && (
                audio?.topicName === topicLabel || topicLabel === '' || topicLabel.toLowerCase().includes('all')
            )) {
                const currentOrder = order++;
                return { ...audio, order: currentOrder, visible: true, selected: currentOrder === 0 };
            }
            return { ...audio, order: -1, visible: false, selected: false };
        });
    } catch (error) {
        console.error(error);
        return audioQueue.map(audio => ({ ...audio }));
    }
}
